import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';

import { mixLinkOnNavEnabled as mixLinkOnNavEnabledSelector } from 'ggApp/modules/featureFlag/selectors';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { SmallHeadline } from 'ggApp/shared/common/Typography';

import { Wrap, Link, Background, Discount, New, Trending, B2B, B2C } from './styled';

const PageList = ({
    className,
    closeMenu,
    isBusinessStore,
    isLoggedIn,
    activeStore,
    mixLinkOnNavEnabled,
    businessStoreDealsEnabled,
}) => {
    const theme = useContext(ThemeContext);
    return (
        <Wrap className={className}>
            <Link external={false} to="/trending" onClick={closeMenu}>
                <Background />
                <Trending color={theme.colors.secondary} />
                <SmallHeadline>
                    <Translator tk="OFFERINGS_LINKS_TOP_PRODUCTS_TEXT" />
                </SmallHeadline>
            </Link>

            {(!isBusinessStore || businessStoreDealsEnabled) && activeStore?.code !== 'us' && (
                <Link external={false} to="/deals" color={theme.colors.Color1} onClick={closeMenu}>
                    <Background />
                    <Discount color={theme.colors.Color1} />
                    <SmallHeadline>
                        <Translator tk="OFFERINGS_LINKS_DEALS_TEXT" />
                    </SmallHeadline>
                </Link>
            )}

            {mixLinkOnNavEnabled && !isBusinessStore && activeStore.code === 'de' && (
                <Link external={false} to="/mix" color={theme.colors.Color1} onClick={closeMenu}>
                    <Background />
                    <New color={theme.colors.Color1} />
                    <SmallHeadline>
                        <Translator tk="MIX_LANDING_NAV_TITLE" />
                    </SmallHeadline>
                </Link>
            )}

            {!isLoggedIn && (activeStore.code === 'de' || isBusinessStore) && (
                <Link
                    external
                    to={
                        isBusinessStore
                            ? `/de-${activeStore.activeLanguage}`
                            : `/business-${activeStore.activeLanguage}/for-business`
                    }
                    onClick={closeMenu}
                >
                    <Background />

                    {isBusinessStore ? <B2C /> : <B2B />}

                    <SmallHeadline>
                        <Translator
                            tk={
                                isBusinessStore
                                    ? 'OFFERINGS_LINKS_B2C_TEXT'
                                    : 'OFFERINGS_LINKS_B2B_TEXT'
                            }
                        />
                    </SmallHeadline>
                </Link>
            )}

            {!isLoggedIn && (activeStore.code === 'at' || activeStore.code === 'nl') && (
                // eslint-disable-next-line
                <Link external color={theme.colors.Color1} onClick={closeMenu} id="open-lead-bot">
                    <Background />
                    <B2B color={theme.colors.secondary} />
                    <SmallHeadline>
                        <Translator
                            tk={
                                isBusinessStore
                                    ? 'OFFERINGS_LINKS_B2C_TEXT'
                                    : 'OFFERINGS_LINKS_B2B_TEXT'
                            }
                        />
                    </SmallHeadline>
                </Link>
            )}
        </Wrap>
    );
};

PageList.propTypes = {
    className: PropTypes.string,
    closeMenu: PropTypes.func,
    isBusinessStore: PropTypes.bool,
    mixLinkOnNavEnabled: PropTypes.bool,
};

PageList.defaultProps = {
    className: '',
    closeMenu: () => {},
    isBusinessStore: false,
    mixLinkOnNavEnabled: false,
};

const enhance = connect(
    createStructuredSelector({
        mixLinkOnNavEnabled: mixLinkOnNavEnabledSelector,
    }),
);

export default enhance(PageList);
